// src/routes/DashboardRoutes.js
import React from "react";
import { Route } from "react-router-dom";
import DashBoard from "../DashBoard/DashBoard";
import Error from "../error/error";
import PrivateRoutes from "./privateRoutes";

function useAdmin() {
  return (
    <>
      <Route element={<PrivateRoutes />}>
        {/* DashBoard */}
        <Route element={<DashBoard />} path="/dashboard" />
        <Route element={<Error />} path="*" />
      </Route>
    </>
  );
}

export default useAdmin;
